<template>
  <div v-if="isLoading" class="d-flex justify-content-center spinner-border text-primary spinner-position form"></div>
  <div v-if="isLoading" class="spinner"></div>
  <o-qr-code-member-modal
      :isVisible="qrCodeModal"
      :corporateLogo="corporateLogo"
      :memberId="memberId"
      :memberName="memberName"
      :corporateName="corporateName"
      :tierName="tierName"
      :tierIcon="tierIcon"
      :memberAvatar="memberAvatar"
      @close="qrCodeModal = false"
  ></o-qr-code-member-modal>
  <div class="d-flex d-md-none">
    <o-user-info-mobile class="mt-4 position-absolute custom-position-user-info" :menuvisibility="userinfo" @showModalSwitch="switchmodal"  @showPrivacyPolicy="showPoliciesModal"
    >
    </o-user-info-mobile>
    <div class="justify-content-sm-evenly navbar-buttom d-flex overflow-scroll scrollable">
      <div class="d-inline-flex d-flex buttom-link" v-for="(list, index) in filteredMenuVisibility" :key="index">
          <router-link
              :to="list.link_spesific"
              class="nav-link m-2"
              aria-current="page"
          >
            <div
				v-if="list.link_name === 'Dashboard'"
				class="d-inline-block me-3 ps-2"
				>
				<svg 
					xmlns="http://www.w3.org/2000/svg"
					width="23"
					height="23"
					fill="currentColor" 
					viewBox="0 0 16 16"
				>
					<path d="M14 7.032c0 3.642-3.134 6.595-7 6.595s-7-2.953-7-6.595C0 3.389 3.134.437 7 .437s7 2.952 7 6.595Zm-6.344.945V2.704c0-.341-.292-.618-.656-.618-.364 0-.656.277-.656.618v5.273C5.7 8.22 5.25 8.812 5.25 9.505c0 .91.785 1.649 1.75 1.649s1.75-.74 1.75-1.65c0-.692-.451-1.285-1.094-1.527ZM3.938 4.971c.483 0 .874-.368.874-.824 0-.456-.39-.825-.875-.825-.483 0-.874.369-.874.825 0 .456.39.824.874.824ZM2.625 6.207c-.483 0-.875.369-.875.825 0 .456.392.824.875.824.484 0 .875-.368.875-.824 0-.456-.391-.825-.875-.825Zm8.75 1.65c.484 0 .875-.37.875-.825 0-.456-.391-.825-.875-.825s-.875.369-.875.825c0 .456.391.824.875.824Zm-1.313-4.535c-.483 0-.874.369-.874.825 0 .456.39.824.874.824.485 0 .876-.368.876-.824 0-.456-.392-.825-.876-.825Z"/>
					</svg>
				</div>
      <div
				v-if="list.link_name === 'MemberDashboard'"
				class="d-inline-block me-3 ps-2"
				>
				<svg 
					xmlns="http://www.w3.org/2000/svg"
					width="23"
					height="23"
					fill="none" 
					viewBox="0 0 16 16"
				>
					<path fill="#fff" d="M14 7.032c0 3.642-3.134 6.595-7 6.595s-7-2.953-7-6.595C0 3.389 3.134.437 7 .437s7 2.952 7 6.595Zm-6.344.945V2.704c0-.341-.292-.618-.656-.618-.364 0-.656.277-.656.618v5.273C5.7 8.22 5.25 8.812 5.25 9.505c0 .91.785 1.649 1.75 1.649s1.75-.74 1.75-1.65c0-.692-.451-1.285-1.094-1.527ZM3.938 4.971c.483 0 .874-.368.874-.824 0-.456-.39-.825-.875-.825-.483 0-.874.369-.874.825 0 .456.39.824.874.824ZM2.625 6.207c-.483 0-.875.369-.875.825 0 .456.392.824.875.824.484 0 .875-.368.875-.824 0-.456-.391-.825-.875-.825Zm8.75 1.65c.484 0 .875-.37.875-.825 0-.456-.391-.825-.875-.825s-.875.369-.875.825c0 .456.391.824.875.824Zm-1.313-4.535c-.483 0-.874.369-.874.825 0 .456.39.824.874.824.485 0 .876-.368.876-.824 0-.456-.392-.825-.876-.825Z"/>
					</svg>
			</div>
                <div
                  v-if="list.link_name === 'Merchant'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-shop-window"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h12V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zm2 .5a.5.5 0 0 1 .5.5V13h8V9.5a.5.5 0 0 1 1 0V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a.5.5 0 0 1 .5-.5z"
                    />
                  </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'Branch Product'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-basket2-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5.929 1.757a.5.5 0 1 0-.858-.514L2.217 6H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.623l1.844 6.456A.75.75 0 0 0 3.69 15h8.622a.75.75 0 0 0 .722-.544L14.877 8h.623a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.717L10.93 1.243a.5.5 0 1 0-.858.514L12.617 6H3.383L5.93 1.757zM4 10a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm3 0a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm4-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
                    />
                  </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'Business Profile'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-person-bounding-box"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"
                    />
                    <path
                      d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                    />
                  </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'User Roles'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-person-fill-gear" viewBox="0 0 16 16">
                    <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4m9.886-3.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"/>
                  </svg>
                </div>
                <div v-else-if="list.link_name === 'Themes'" class="d-inline-block me-3 ps-2">
                        <i class="fas fa-paint-brush" style="font-size: 16px; color: currentColor;"></i>
                    </div>
                <div v-else-if="list.link_name === 'Configuration'" class="d-inline-block me-3 ps-2">
                    <i class="fas fa-cog" style="font-size: 20px; color: currentColor;"></i>
                </div>
                <div
                  v-else-if="list.link_name === 'User'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-person-plus-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                    />
                  </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'Corporate'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="white"
                    class="bi bi-building"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"
                    />
                    <path
                      d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z"
                    />
                  </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'Feature Flags'"
                  class="d-inline-block me-3 ps-2"
                >
                    <i class="fas fa-flag" style="font-size: 20px; width: 20px; height: 20px; color: currentColor;"></i>
                </div>
                <div
                  v-else-if="list.link_name === 'Branch'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-diagram-3-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"
                    />
                  </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'Member'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-people-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
                    />
                    <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                  </svg>
                </div>
                <div
                    v-else-if="list.link_name === 'Tax Service'"
                    class="d-inline-block me-3 ps-2"
                >
                    <i class="fas fa-file-invoice" style="font-size: 16px; width: 20px; height: 20px;"></i>
                </div>
                <div
                  v-else-if="list.link_name === 'Product'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-basket2-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5.929 1.757a.5.5 0 1 0-.858-.514L2.217 6H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.623l1.844 6.456A.75.75 0 0 0 3.69 15h8.622a.75.75 0 0 0 .722-.544L14.877 8h.623a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.717L10.93 1.243a.5.5 0 1 0-.858.514L12.617 6H3.383L5.93 1.757zM4 10a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm3 0a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm4-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
                    />
                  </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'Point Plan'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-calendar2-check-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-2.6 5.854a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                    />
                  </svg>
                </div>
                <div v-else-if="list.link_name === 'Expiration'" class="d-inline-block me-3 ps-2">
                    <i class="fas fa-hourglass-end" style="font-size: 16px; width: 20px; height: 20px;"></i>
                </div>
                <div v-else-if="list.link_name === 'Marketing'" class="d-inline-block me-3 ps-2">
                    <i class="fas fa-bullhorn" style="font-size: 16px; width: 20px; height: 20px;"></i>
                </div>
                <div v-else-if="list.link_name === 'Promotions'" class="d-inline-block me-3 ps-2">
                    <i class="fas fa-tags" style="font-size: 16px; width: 20px; height: 20px;"></i>
                </div>
                <div v-else-if="list.link_name === 'Newsletter'" class="d-inline-block me-3 ps-2">
                    <i class="fas fa-newspaper" style="font-size: 16px; width: 20px; height: 20px;"></i>
                </div>
                <div
                  v-else-if="list.link_name === 'Transaction'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-cash-coin"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
                    />
                    <path
                      d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z"
                    />
                    <path
                      d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z"
                    />
                    <path
                      d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z"
                    />
                  </svg>
                </div>
                <div
                    v-else-if="list.link_name === 'Manipulation'"
                    class="d-inline-block me-3 ps-2"
                >
                    <i class="far fa-money-bill-alt" style="font-size: 16px; width: 20px; height: 20px; color: currentColor;"></i>
                </div>
                <div
                  v-else-if="list.link_name === 'MemberTransaction'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-cash-coin"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
                    />
                    <path
                      d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z"
                    />
                    <path
                      d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z"
                    />
                    <path
                      d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z"
                    />
                  </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'Benefit'"
                  class="d-inline-block me-3 ps-2"
                >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                      </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'Voucher'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-ticket-perforated"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M4 4.85v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Z"
                    />
                    <path
                      d="M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3h-13ZM1 4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1.05a2.5 2.5 0 0 0 0 4.9v1.05a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1.05a2.5 2.5 0 0 0 0-4.9V4.5Z"
                    />
                  </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'Voucher Gift'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-gift" viewBox="0 0 16 16">
                    <path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5V7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zM1 4v2h6V4H1zm8 0v2h6V4H9zm5 3H9v8h4.5a.5.5 0 0 0 .5-.5V7zm-7 8V7H2v7.5a.5.5 0 0 0 .5.5H7z"/>
                  </svg>
                </div>
                <div
                  v-else-if="list.link_name === 'Voucher Redeem'"
                  class="d-inline-block me-3 ps-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-ticket-perforated-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5Zm4-1v1h1v-1H4Zm1 3v-1H4v1h1Zm7 0v-1h-1v1h1Zm-1-2h1v-1h-1v1Zm-6 3H4v1h1v-1Zm7 1v-1h-1v1h1Zm-7 1H4v1h1v-1Zm7 1v-1h-1v1h1Zm-8 1v1h1v-1H4Zm7 1h1v-1h-1v1Z"
                    />
                  </svg>
                </div>
                <div
                    v-if="list.link_name === 'System Log'"
                    class="d-inline-block me-3 ps-2"
                    >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-journal-text"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
                        />
                        <path
                        d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"
                        />
                        <path
                        d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
                        />
                    </svg>
                    </div>
                    <div
                        v-if="list.link_name === 'API Log'"
                        class="d-inline-block me-3"
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-code" viewBox="0 0 16 16">
                            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z"/>
                            <path d="M8.646 6.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 9 8.646 7.354a.5.5 0 0 1 0-.708m-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 9l1.647-1.646a.5.5 0 0 0 0-.708"/>
                        </svg>
                    </div>
                    <div
                      v-if="list.link_name === 'Member Tier'"
                        class="d-inline-block me-3 ps-2"
                      >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z"/>
                      </svg>
                    </div>
                    <div
                      v-if="list.link_name === 'Transaction Report'"
                        class="d-inline-block me-3 ps-2"
                      >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-journal-text"
                        viewBox="0 0 16 16"
                    >
                        <path
                        d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
                        />
                        <path
                        d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"
                        />
                        <path
                        d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"
                        />
                    </svg>
                    </div>
                    <div
                        v-if="list.link_name === 'Policies'"
                        class="d-inline-block me-3 ps-2"
                        >
                        <i class="fa fa-balance-scale" style="font-size: 16px; width: 20px; height: 20px;"></i>
                    </div>
        </router-link>
      </div>
    </div>
  </div>
  <o-modal
    v-if="showPrivacyModal" 
    @close="closePrivacyModal"
    :modalClass="'show d-block'"
    :bodyClass="'p-0'"
    :allow-html="false"
    :is-footer-visible="false"
    >
    <template #header>
      <h5 class="modal-title">Policies</h5>
    </template>
    <template #body>
      <div class="policies-container"
        style="height: 450px;
              max-height: 450px;
              min-height: 450px;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              color: black;
              word-wrap: break-word;
              ">
        <div class="policies-tabs">
          <button 
            class="tab-button" 
            :class="{ active: activeTab === 'privacy' }"
            @click="activeTab = 'privacy'">
            Privacy Policy
          </button>
          <button 
            class="tab-button" 
            :class="{ active: activeTab === 'terms' }"
            @click="activeTab = 'terms'">
            Terms & Conditions
          </button>
        </div>
        
        <div class="tab-content" style="height: 450px; max-height: 450px; min-height: 450px; overflow-y: auto; padding: 1.5rem 1.5rem 2.5rem 1.5rem; flex: 1;">
          <div v-if="activeTab === 'privacy'" class="policy-content">
            <PublicPolicyDisplay type="privacy" />
          </div>
          
          <div v-if="activeTab === 'terms'" class="policy-content">
            <PublicPolicyDisplay type="terms" />
          </div>
        </div>
      </div>
    </template>
  </o-modal>
</template>

<script>
import {OUserInfoMobile, OQrCodeMemberModal, OModal} from "@/components/OmnihControl";
import PublicPolicyDisplay from '@/components/PublicPolicyDisplay.vue';
import { eventBus } from '@/eventBus';
import { mapState, useStore } from 'vuex';

export default {
    props: [
        'menuvisibility',
        'userinfo',
        'switchmodal'
    ],
    components: {
      OUserInfoMobile,
      OQrCodeMemberModal,
      OModal,
      PublicPolicyDisplay,
    },
    data() {
        return {
          qrCodeModal: false,
          memberId: '',
          memberName: '',
          corporateName: '',
          corporateLogo: '',
          tierName: '',
          tierIcon: '',
          memberAvatar: '',
          user: '',
          isLoading: true,
          policyTabs: [],
          activeTab: 'privacy',
          isVoucherExpanded: false,
          showPrivacyModal: false
        }
    },
    computed: {
      flattenedMenu() {
        let flat = [];
        if (!this.menuvisibility) return flat;
        for (let item of this.menuvisibility) {
           if (item.is_dropdown && item.children) {
               flat.push(...item.children);
           } else {
               flat.push(item);
           }
        }
        return flat;
      },
      ...mapState({
        userStore: state => state.Auth.currUser
      }),
      filteredMenuVisibility() {
        if (!this.menuvisibility) return [];
        
        const menu = this.menuvisibility.map(item => {
          if (item.link_name === 'Voucher Redeem') return { ...item, link_spesific: '/voucher/redeem' };
          if (item.link_name === 'Voucher Gift') return { ...item, link_spesific: '/voucher/gift' };
          return item;
        });

        const voucherIndex = menu.findIndex(item => item.link_name === 'Voucher');
        
        if (voucherIndex !== -1) {
          const relatedNames = ['Voucher Redeem', 'Voucher Gift'];
          const relatedItems = menu.filter(item => relatedNames.includes(item.link_name));
          const cleanedMenu = menu.filter(item => !relatedNames.includes(item.link_name));
          
          const finalIndex = cleanedMenu.findIndex(item => item.link_name === 'Voucher');
          cleanedMenu.splice(finalIndex + 1, 0, ...relatedItems);
          
          return cleanedMenu;
        }
        
        return menu;
      },
      isVoucherActive() {
        return this.menuvisibility.some(item => 
          ['Voucher', 'Voucher Redeem', 'Voucher Gift'].includes(item.link_name) && 
          this.$route.path.startsWith(item.link_spesific)
        );
      }
    },
    setup() {
      const store = useStore();
      return { store };
    },
    methods: {
      async showQrCode() {
        // Ensure we have tier icon
        if (!this.tierIcon) {
          try {
             // We use store dispatch directly here
             const res = await this.store.dispatch('ClientDashboard/read');
             if (res?.data?.data?.tier?.icon?.image_url) {
               this.tierIcon = res.data.data.tier.icon.image_url;
             }
          } catch (e) {
             console.log('Failed to fetch dashboard for QR icon', e);
          }
        }
        this.qrCodeModal = true;
        eventBus.emit('navigation-triggered', 'navbar-mobile.vue');
      },
      loadMemberId() {
        this.memberId = this.user.member.id;
      },
      loadMemberName() {
        this.memberName = this.user.member.title + ' ' + this.user.member.first_name + ' ' + this.user.member.last_name;
      },
      loadCorporateName() {
        this.corporateName = this.user.member.corporate_name;
      },
      loadCorporateLogo() {
        this.corporateLogo = this.user.member.corporate_logo;
      },
      loadTierName() {
        this.tierName = this.user.member.tier_name;
      },
      loadMemberAvatar() {
        this.memberAvatar = this.user.member.member_avatar;
      },
      async showPoliciesModal() {
        this.showPrivacyModal = true;
      },
      closePrivacyModal() {
        this.showPrivacyModal = false;
      },
      toggleVoucher() {
        this.isVoucherExpanded = !this.isVoucherExpanded;
      },
      isActiveVoucherChild(link) {
        return this.$route.path === link || this.$route.path.startsWith(link + '/');
      }
    },
    watch: {
      userStore: {
        handler(newVal) {
          if (newVal?.member) {
            this.user = newVal;
            this.loadMemberId();
            this.loadMemberName();
            this.loadCorporateName();
            this.loadCorporateLogo();
            this.loadTierName();
            this.tierIcon = newVal.member.tier?.icon?.image_url || '';
            this.loadMemberAvatar();
          }
          this.isLoading = false;
        },
        immediate: true,
        deep: true
      },
      $route: {
        handler() {
          if (this.isVoucherActive) {
            this.isVoucherExpanded = true;
          }
        },
        immediate: true
      }
    }
}
</script>

<style>
/* Navbar at the bottom */
.navbar-buttom {
    background-color: #CB5B5B;
    position: fixed;
    z-index: 100;
    bottom: 0;
    width: 100%;        
    min-height: 50px;
    flex: 0 0 auto;
    left: 0; 
    box-sizing: border-box; 
    margin-bottom: 0px !important;
}

.bg-white-transparent {
    background-color: rgba(255, 255, 255, 0.2);
}

.sub-link-mobile {
    font-size: 12px !important;
    white-space: nowrap;
    padding-left: 10px;
    padding-right: 10px;
    color: rgba(255, 255, 255, 0.7) !important;
}

.sub-link-mobile.active {
    color: #fff !important;
    font-weight: 600;
}

.navbar-buttom .nav-link.active {
    color: #ffffff !important;
}


.container {
    overflow: hidden;
}


.navbar-buttom .buttom-link a.nav-link.router-link-exact-active {
    color: #ffffff !important;
}


.navbar-buttom .buttom-link a.nav-link.router-link-exact-active::before {
    display: block;
    content: "";
    position: absolute;
    bottom: 0;

    border-radius: 3px;
    background-color: white;
    transition: background-color 0.15s linear 0s;
    height: 5px;
    width: 40px;
}


.custom-position-user-info {
    position: absolute;
    top: 0px; 
    right: 20px; 
    z-index: 101; 
}


.scrollable {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.scrollable::-webkit-scrollbar {
    display: none;
}


.navbar-buttom .nav-link {
    color: rgba(255, 255, 255, 0.7);
}


@media screen and (max-width: 375px) {
    .navbar-buttom {
        width: 100%; 
        left: 0; 
        box-sizing: border-box; 
    }

    .container {
        overflow: hidden; 
    }


    .navbar-buttom .nav-link {
        font-size: 14px; 
    }


    .custom-position-user-info {
        right: 10px; 
    }
}

/* Responsiveness for screens larger than 375px */
@media screen and (min-width: 376px) {
    .navbar-buttom {
        width: 100%; /* Ensure navbar stretches fully */
    }

    .container {
        overflow: visible; /* Allow overflow in container if needed */
    }

    .navbar-buttom .nav-link {
        font-size: 16px; /* Default text size for larger screens */
    }

    .custom-position-user-info {
        right: 20px; /* Reset user info position for larger screens */
    }
}

.policies-tabs {
  display: flex;
  border-bottom: 1px solid #dee2e6;
  background-color: #f8f9fa;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
}

.tab-button {
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  background-color: transparent;
  color: #6c757d;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 3px solid transparent;
}

.tab-button:hover {
  background-color: #e9ecef;
  color: #495057;
}

.tab-button.active {
  color: #cb5b5b;
  background-color: #fff;
  border-bottom-color: #cb5b5b;
  font-weight: 600;
}

.policy-content {
  padding-bottom: 1.5rem;
}

</style>